export interface DuplicateCheckItem {
  uid: string;
  status: string;
  info?: { md5?: string } | null;
}

/**
 * 判断是否存在仍在计算 MD5 的文件项。
 * 仅针对已进入上传列表（info 有值）且尚未拿到 md5 的项，
 * 用于开启“过滤内容相同素材”后禁用提交，避免去重结果不稳定。
 */
export function computeHasPendingMd5(items: DuplicateCheckItem[]): boolean {
  return items.some((item) => item.info && !item.info.md5);
}

/**
 * 去重分组键：同组内的文件才参与 md5 对比，不同组互不影响。
 * 文件夹上传时按文件夹路径分组，不同文件夹中的相同内容素材允许共存。
 */
export function computeDuplicateUids<T extends DuplicateCheckItem>(
  items: T[],
  enabled: boolean,
  getGroupKey?: (item: T) => string
): Set<string> {
  if (!enabled) return new Set();

  // 分组后按列表顺序记录每个组内 md5 最后一次出现（即保留）的成功项
  const lastKeptByGroupAndMd5 = new Map<string, string>();
  for (const item of items) {
    if (item.status === 'success' && item.info?.md5) {
      const groupKey = getGroupKey ? getGroupKey(item) : '';
      lastKeptByGroupAndMd5.set(`${groupKey}|${item.info.md5}`, item.uid);
    }
  }

  const duplicateUids = new Set<string>();
  for (const item of items) {
    if (item.status === 'success' && item.info?.md5) {
      const groupKey = getGroupKey ? getGroupKey(item) : '';
      if (lastKeptByGroupAndMd5.get(`${groupKey}|${item.info.md5}`) !== item.uid) {
        duplicateUids.add(item.uid);
      }
    }  }

  return duplicateUids;
}
